import {inject, Injectable} from "@angular/core";
import {HttpClient, HttpContext} from "@angular/common/http";
import {MessageService} from "./message.service";
// eslint-disable-next-line @typescript-eslint/naming-convention
import Config from "../../config/Config";
import {BYPASS_ERROR} from "../../interceptors/server-error.interceptor";

@Injectable({
	providedIn: "root",
})
export class TicketService {
	public http = inject(HttpClient);
	public messageService = inject(MessageService);

	sendTicket(ticketData: FormData) {
		return this.http.post<string>(Config.services.ticket, ticketData, {
			responseType: "text" as "json",
			context: new HttpContext().set(BYPASS_ERROR, true),
		});
	}
}
